import {
  Address, AddressComponent, CustomerLocation, CustomerLocationComponent,
  GeoCoordinates, getLanguageOfCountry, isNullOrUndefined,
  isNullOrUndefinedOrEmpty, Language, TimeZoneRegion,
} from 'in-time-core';
import { GeoLocationService } from '../geo-location.service';

export class LocationDataFactory {
  constructor(private readonly geoLocationService: GeoLocationService) {}

  createComponent(): CustomerLocationComponent {
    const location = this.createLocation();
    return new CustomerLocationComponent(location);
  }

  createLocation(): CustomerLocation {
    return new CustomerLocation(
      this.getCustomerAddress(),
      this.getCustomerGeoLocation(),
      this.getCustomerTimeZone(),
    );
  }

  getCustomerAddress(override?: { city?: string | null }): Address | null {
    const region = isNullOrUndefinedOrEmpty(override?.city) ? this.geoLocationService.region : null;
    const city = isNullOrUndefinedOrEmpty(override?.city) ? this.geoLocationService.city : override?.city;

    const countryCode = this.geoLocationService.countryCode;
    const country = this.geoLocationService.country;
    const language = isNullOrUndefined(country) ? Language.English : (getLanguageOfCountry(country) ?? Language.English);
    const regionComponent = isNullOrUndefined(region) ? null : AddressComponent.fromName(region, language);
    const cityComponent = isNullOrUndefined(city) ? null : AddressComponent.fromName(city, language);

    if(countryCode == null && regionComponent == null && cityComponent == null) {
      return null;
    }

    return Address.create({
      country: countryCode,
      administrativeAreaLevel1: regionComponent,
      locality: cityComponent,
    });
  }

  getCustomerGeoLocation(): GeoCoordinates | null {
    const latitude = this.geoLocationService.latitude;
    const longitude = this.geoLocationService.longitude;

    if(isNullOrUndefined(latitude) || isNullOrUndefined(longitude)) {
      return null;
    }

    return new GeoCoordinates(latitude, longitude);
  }

  getCustomerTimeZone(): TimeZoneRegion | null {
    return this.geoLocationService.timezone;
  }
}
